"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appBasePageDeclarations = appBasePageDeclarations;
/**
 * The declarations of the manifest a page gets, from the controls its page
 * rights show: a declaration of actions follows the controls (an action the
 * page rights hide is not named to the page either), the rules name the
 * actions of the page that write a row. An author preview declares no
 * capability; its host answers without them. The platform and the StreamKit
 * hand the page exactly this.
 */
function appBasePageDeclarations(manifest, controls) {
    const shown = (actionId) => controls.some(control => control.actionId === actionId);
    const ruleActions = Object.fromEntries(manifest.actions.flatMap(action => (action.type === 'rowInsert' ||
        (action.type === 'ownRowChange' && action.operation === 'update')) &&
        shown(action.id)
        ? [
            [
                action.id,
                {
                    sourceKey: action.sourceKey,
                    insert: action.type === 'rowInsert',
                },
            ],
        ]
        : []));
    return {
        capabilities: (manifest.capabilities ?? []).filter(capability => capability.actionIds.length === 0 || capability.actionIds.some(shown)),
        ...(manifest.rules?.rules.length
            ? { rules: { ruleSet: manifest.rules, actions: ruleActions } }
            : {}),
        ...(manifest.derivedSources?.length
            ? {
                derivedSources: Object.fromEntries(manifest.derivedSources.map(({ key, ...derived }) => [key, derived])),
            }
            : {}),
    };
}
